import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import { AjaxService } from 'src/app/services/ajax.service';
import { CommonService } from 'src/app/services/common.service';
import { serverUrl } from 'src/environments/environment';
@Component({
  selector: 'app-temparaturechart',
  templateUrl: './temparaturechart.component.html',
  styleUrls: ['./temparaturechart.component.scss'],
})
export class TemparaturechartComponent implements OnInit, OnChanges {
  batteryValues: Array<any> = [];
  show: Boolean = false;
  @Input() selVin;
  temp: string = 'TEMPERATURESENSOR1'; // Default temperature sensor
  value: string = 'TEMP1'; // Default value for temperature sensor
  @ViewChild('temperatureSensor', { static: false }) temperatureSensor;

  temperatureList = [
    { tempName: 'Temperature Sensor 1', value: 'TEMP1', temp: 'TEMPERATURESENSOR1' },
    { tempName: 'Temperature Sensor 2', value: 'TEMP2', temp: 'TEMPERATURESENSOR2' },
    { tempName: 'Temperature Sensor 3', value: 'TEMP3', temp: 'TEMPERATURESENSOR3' },
    { tempName: 'Temperature Sensor 4', value: 'TEMP4', temp: 'TEMPERATURESENSOR4' },
    { tempName: 'BT Temperature Sensor 1', value: 'BLEtemp1', temp: 'BTTEMPERATURESENSOR1' },
    { tempName: 'BT Temperature Sensor 2', value: 'BLEtemp2', temp: 'BTTEMPERATURESENSOR2' },
    { tempName: 'BT Temperature Sensor 3', value: 'BLEtemp3', temp: 'BTTEMPERATURESENSOR3' },
    { tempName: 'BT Temperature Sensor 4', value: 'BLEtemp4', temp: 'BTTEMPERATURESENSOR4' },
  ]

  constructor(private api: AjaxService, private commonService: CommonService) { }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("selVin", this.selVin);
    this.fetchData(this.selVin)
  }
  today = new Date();
  selectedDate = this.today.toISOString().split('T')[0];

  filterDataByDate() {
    console.log('Filtering data for:', this.selectedDate);
    this.fetchData(this.selVin);
  }

  fetchData(vin) {
    let url = serverUrl.web + "/report/TemperatureReport" + '?vin=' + vin + '&fromDate=' + this.selectedDate + " " + '00:00:00' + '&toDate=' + this.selectedDate + " " + '23:59:59' + '&userId=' + localStorage.userName + '&type=' + this.value + '&temp=' + this.temp;


    //let body = '?vin=' + vin + '&fromDate=' + this.selectedDate + " " + '00:00:00' + '&toDate=' + this.selectedDate + " " + '23:59:59' + '&userId=' + localStorage.userName + '&type=' + "TEMP1" + '&temp=TEMPERATURESENSOR1';


    this.api.ajaxGetWithString(url).subscribe(res => {
      console.log("res", res);
      let parsedRes = typeof res === 'string' ? JSON.parse(res) : res;

      if (parsedRes[0] && 'status' in parsedRes[0] && parsedRes[0].status) {
        this.batteryValues = [];
        this.commonService.presentToast(parsedRes[0].status);
      } else {
        this.batteryValues = parsedRes.map(el => {
          let dateObj = new Date(el.beginAt);
          let trimmeddate = `${dateObj.toLocaleString('en-us', { month: 'short' })}-${dateObj.getDate()} ${(dateObj.getHours() % 12 || 12).toString().padStart(2, '0')
            }:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          let totalSeconds = dateObj.getHours() * 3600 + dateObj.getMinutes() * 60 + dateObj.getSeconds() + dateObj.getMilliseconds() / 1000;

          return [parseFloat(el.TEMP.split("°C")[0]), totalSeconds, el.volt, trimmeddate]; // Ensure percentage is a number
        });
        this.batteryValues.sort((a, b) => a[0] - b[0]);
        this.batteryValues.sort((a, b) => a[1] - b[1]);
      }




      this.show = true;
      this.renderChart()
    })
  }

  renderedItem(event, items, list) {
    //this.commonService.renderedItem(event, items, list);
    this.temp = this.temperatureSensor.getSelectedItem().originalItem.temp
    this.value = this.temperatureSensor.getSelectedItem().value
    this.fetchData(this.selVin);
  }
  //   renderChart() {
  //     let options: Highcharts.Options = {
  //       chart: {
  //         type: 'spline',
  //         inverted: false,
  //         zooming: {
  //           type: 'x',
  //           singleTouch: true
  //       }
  //       },
  //       title: {
  //         text: '🔋 Battery Performance Analysis'
  //       },

  //       subtitle: {
  //         text: 'Voltage and Charge Trends Over Time'
  //       },
  //       xAxis: {
  //         type: 'category',
  //         reversed: false,
  //         title: {
  //           text: 'Time (HH:MM)'
  //         },
  //         labels: {
  //           formatter: function () {
  //             let seconds = this.value as number;
  //             let hours = Math.floor(seconds / 3600);
  //             let minutes = Math.floor((seconds % 3600) / 60);
  //             let secs = Math.floor(seconds % 60);
  //             return `${hours}:${minutes.toString().padStart(2, '0')}`;
  //           }
  //         },
  //         maxPadding: 0.05,
  //  tickInterval: 7200,
  //         min: 0,
  //         showLastLabel: true
  //       },
  //       yAxis: {
  //         title: {
  //           text: 'SOC'
  //         },
  //         labels: {
  //           format: '{value}%',
  //           style: {
  //             fontSize: '12px'
  //           }
  //         },
  //         min: 0, max: 100, tickInterval: 10,
  //       }
  //       ,
  //       legend: {
  //         enabled: false
  //       },
  //       tooltip: {
  //         headerFormat: '<b>{series.name}</b><br/>',
  //         formatter: function () {
  //           return `<b>${this.series.name} : ${this.point["volt"]} <br/> 
  //               <b>Time : ${this.point["time"]} <br/>`;
  //         },
  //         style: {
  //           fontSize: '10px',  
  //         },
  //         borderColor: '#a68c00',
  //         borderWidth: 1,
  //       },

  //       credits: { enabled: false },

  //       plotOptions: {
  //         spline: {
  //           marker: {
  //             enabled: true,
  //             radius: 1,
  //             symbol: 'circle',
  //             fillColor: '#000000',
  //             lineWidth: 2,
  //             lineColor: '#000000'
  //           }
  //         }
  //       },
  //       series: [{
  //         type: 'spline',
  //         name: 'Voltage',
  //         color: 'transparent',
  //         lineWidth: 0,
  //         marker: {
  //           enabled: true,
  //           symbol: 'diamond',
  //           lineColor: "#ffd700",
  //           radius: 5,
  //           fillColor: '#ffd700'
  //         },
  //         data: this.batteryValues.map(entry => ({
  //           x: entry[1],
  //           y: entry[0],
  //           volt: entry[2],
  //           time: entry[3]
  //         }))

  //       }]
  //     };

  //     setTimeout(() => {
  //       Highcharts.chart('fuelchart', options);
  //     }, 1000);
  //   }

  renderChart() {
    let options: Highcharts.Options = {
      chart: {
        type: 'areaspline', // Use areaspline for a wave-like appearance
        inverted: false,
        zooming: {
          type: 'x',
          singleTouch: true
        }
      },
      title: {
        text: '🌡 Temperature Analysis'
      },
      subtitle: {
        text: 'Temperature Trends Over Time'
      },
      xAxis: {
        type: 'category',
        reversed: false,
        title: {
          text: 'Time (HH:MM)'
        },
        labels: {
          formatter: function () {
            let seconds = this.value as number;
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds % 3600) / 60);
            return `${hours}:${minutes.toString().padStart(2, '0')}`;
          }
        },
        maxPadding: 0.05,
        tickInterval: 7200,
        min: 0,
        showLastLabel: true
      },
      yAxis: {
        title: {
          text: 'Temperature (°C)'
        },
        labels: {
          format: '{value}°C',
          style: {
            fontSize: '12px'
          }
        },
        min: 0,
        max: 100,
        tickInterval: 10,
      },
      legend: {
        enabled: true
      },
      tooltip: {
        headerFormat: '<b>{series.name}</b><br/>',
        formatter: function () {
          return `<b> ${this.series.name} : ${this.y}°C <br/> 
            <b>Time : ${this.point["time"]} <br/>`;
        },
        style: {
          fontSize: '10px',
        },
        borderColor: '#a68c00',
        borderWidth: 1,
      },
      credits: { enabled: false },
      plotOptions: {
        areaspline: { // Changed to areaspline options
          fillOpacity: 0.3, // Partially transparent fill
          marker: {
            enabled: true,
            radius: 3,
            symbol: 'circle',
            fillColor: '#ffd700',
            lineWidth: 1,
            lineColor: '#000000'
          },
          lineWidth: 2,
          // Add wave-like animation if desired
          animation: {
            duration: 1500
          }
        }
      },
      series: [{
        type: 'areaspline', // Changed to areaspline
        name: 'Temperature',
        color: '#ffd700',
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgba(255, 215, 0, 0.8)'],
            [1, 'rgba(255, 215, 0, 0.1)']
          ]
        },
        data: this.batteryValues.map(entry => ({
          x: entry[1],
          y: entry[0],
          volt: entry[2],
          time: entry[3]
        }))
      }]
    };

    setTimeout(() => {
      Highcharts.chart('fuelchart', options);
    }, 1000);
  }

  ngOnInit() {
    // this.fetchData()
  }

}
